import React from 'react';
import { CommonError } from '../CommonError/CommonError.js';
import ErrorIcon from './ErrorIcon.js';

const ErrorResponse = (props) => {
    const { onClick } = props;
    return (React.createElement(CommonError, { icon: React.createElement(ErrorIcon, null), buttonText: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441", title: "\u0423\u043F\u0441, \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A", subTitle: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441", onClick: onClick }));
};
ErrorResponse.displayName = 'ErrorResponse';

export { ErrorResponse };
//# sourceMappingURL=ErrorResponse.js.map
